import React, { useState } from 'react';
import ListTables from '../../components/shared/tables';
import Base from '../base';
import { Alert } from '@themesberg/react-bootstrap';
import SearchFormInspect from '../../components/widgets/formSearch';
import { post, get } from '../../services/back.service';
import ModalMessage from '../../components/widgets/modalMessage';
import ReportActions from '../../components/shared/ReportActions';

function InspectionModifyState() {
  const [infoReport, setInfoReport] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectInspect, setSelectInspect] = useState(0);
  const [selectId, setSelectId] = useState(0);
  const [currentFilter, setCurrentFilter] = useState({});
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type: '',
  });

  const editButton = (row) => {
    return (
      <ReportActions
        showReopen={true}
        reopenDisabled={!(row.state === 'I' || row.state === 'T')}
        onReopen={() => {
          setAlert({ show: false });
          setShowModal(true);
          setSelectInspect(row.encryptid);
          setSelectId(row.id);
        }}
      />
    );
  };

  const searching = async (data) => {
    setCurrentFilter(data);
    const body = data;
    const respoReport = await post('/peritaje/inspectionreport/', body);
    if (respoReport.success) {
      setInfoReport(respoReport.data);
    } else {
      console.log(respoReport);
    }
  };

  const modifyState = async () => {
    const respoReport = await get('/peritaje/reopen/' + selectInspect, {});
    if (respoReport.success) {
      setAlert({
        show: true,
        message: 'Perijate modificado correctamente',
        type: 'success',
      });
    } else {
      setAlert({
        show: true,
        message: respoReport.message,
        type: 'danger',
      });
    }
    setShowModal(false);
    searching(currentFilter);
  };

  return (
    <Base>
      {alert.show && (
        <Alert
          variant={alert.type}
          onClose={() => setAlert({ show: false })}
          dismissible
        >
          {alert.message}
        </Alert>
      )}
      <ModalMessage
        title={'Advertencia'}
        text={`El peritaje No ${selectId} se podra editar de nuevo, esta seguro?`}
        showProps={showModal}
        funcAccept={modifyState}
        funcClose={() => setShowModal(false)}
      />
      <SearchFormInspect searching={searching} />
      <ListTables
        hideFirst={true}
        data={infoReport}
        editar={editButton}
        messageWd="sin peritajes en el filtro"
        headerAlwaysShow={true}
      />
    </Base>
  );
}

export default InspectionModifyState;
